import Houses from "../components/views/houses/houses.vue";

const routes = [
  {
    path: "houses",
    component: Houses,
    name: "houses",
    meta: {
      description: "List of Houses",
      title: "Houses",
      requiresAuth: true,
    },
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/houses.route.js